import { Pipe, PipeTransform } from '@angular/core';
import { MealService } from './meal-service.model';

@Pipe({
  name: 'mealServiceFilter'
})
export class MealServiceFilterPipe implements PipeTransform {

  transform(meal: MealService[], fromDate?: Date, toDate?: Date): any {
    return meal.filter(
      o => ((fromDate == null || new Date(o.Date) >= fromDate)
        && (toDate == null || new Date(o.Date) <= toDate))
    );
  }
}
